<button
  (click)="handleClick()"
  (mouseover)="onMouseOver()"
  (mouseout)="onMouseOut()"
  class="px-4 py-2 text-sm rounded-full border transition-colors"
  [ngStyle]="buttonStyle"
>
  {{ text }}
</button>
